import React, { useState } from 'react';
import { Form, Input, Button, Icon, Checkbox, Tooltip, DatePicker, Switch, Popover } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { PayoutLink } from '../../../../models';
import { connect } from 'react-redux';
import { alertify, handleApiExceptions } from '../../../../app_methods';
import { MerchantService } from '../../../../services';
import moment from 'moment';


let PayoutLinkForm = (props) => {
    const [isGenerating, setIsGenerating] = useState(false);

    const { form, payout_link } = props;
    const { getFieldDecorator } = form;
    const validations = PayoutLink.validations;

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            if (!values.payee_email && !values.payee_phone) {
                alertify("Oops!", "You need to provide either payee email or phone number.", "error");
                return;
            }
            if (!values.allowed_beneficiary_types.length) {
                alertify("Oops!", "You need to allow atleast one beneficiary type.", "error");
                return;
            }
            props.onSubmit(form.getFieldsValue());
        });
    }

    const generateUniqueCode = () => {
        setIsGenerating(true);
        MerchantService.generate_ulc().then(response => {
            if (response.success) form.setFieldsValue({ "unique_code": response.data.unique_link_code })
            setIsGenerating(false);
        }).catch(error => {
            setIsGenerating(false);
            handleApiExceptions(error);
        })
    };

    const renderUniqueCodeExtra = () => {
        return (
            <Tooltip title="Generate Random">
                <Icon type="setting" spin={isGenerating} onClick={generateUniqueCode} />
            </Tooltip>
        )
    };

    const getBeneficiaryTypes = () => {
        const merchant_payment_modes =  props.current_user.payment_modes;
        let beneficiary_types = [];
        if (!merchant_payment_modes.length) return beneficiary_types;
        if (merchant_payment_modes.includes("IMPS")) beneficiary_types.push({ label: "Bank Account", value: "bank_account" });
        if (merchant_payment_modes.includes("UPI")) beneficiary_types.push({ label: "UPI", value: "upi" });
        return beneficiary_types;
    };

    const getBeneficiaryTypesInitialValue = () => {
        const merchant_payment_modes =  props.current_user.payment_modes;
        let beneficiary_types = [];
        if (!merchant_payment_modes.length) return beneficiary_types;
        if (merchant_payment_modes.includes("IMPS")) beneficiary_types.push("bank_account");
        if (merchant_payment_modes.includes("UPI")) beneficiary_types.push("upi");
        return beneficiary_types;
    };

    const getBeneTypes = () => {
        const merchant_payment_modes =  props.current_user.payment_modes;
        let beneficiary_types = [];
        if (!merchant_payment_modes.length) return beneficiary_types;
        if (merchant_payment_modes.includes("IMPS")) beneficiary_types.push({ label: "Bank Account", value: "bank_account" });
        if (merchant_payment_modes.includes("UPI")) beneficiary_types.push({ label: "UPI", value: "upi", disabled: true, checked: false});
        return beneficiary_types;
    };

    const renderUniqueCodeLabel = () => {
        return (
            <div className="d-inline">
                <span className="mr-1">Unique Name:</span>
                <Popover
                    overlayStyle={{ maxWidth: 600 }}
                    content="You can enter unique name for your link. e.g. cashback-for-grocery, refund-link etc. You can autogenerate it by clicking on the cog button."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover>
            </div>
        )
    };

    const renderSkipAuthenticationLabel = () => {
        return (
            <div className="d-inline">
                <span className="mr-1">Skip Authentication:</span>
                <Popover
                    overlayStyle={{ maxWidth: 600 }}
                    content="Authentication code will be generated for this link which you need to send to the payee for executing the payout link. You can skip authentication by below toggle button."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover>
            </div>
        )
    };

    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: payout_link.id
            })(<Input autoComplete='off' hidden />)}

            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Form.Item label="Payee Name">
                        {getFieldDecorator("payee_name", {
                            rules: validations.payee_name
                        })(<Input autoComplete='off' prefix={<Icon type="profile" />} />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Payee Email ID">
                        {getFieldDecorator("payee_email", {
                            rules: validations.payee_email
                        })(<Input autoComplete='off' prefix={<Icon type="mail" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Payee Phone Number">
                        {getFieldDecorator("payee_phone", {
                            rules: validations.payee_phone
                        })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
                    </Form.Item>
                </div>
            </div>
            
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Amount">
                        {getFieldDecorator("amount", {
                            rules: validations.amount
                        })(<Input autoComplete='off' onChange={(e) => {
                            if(e.target.value > 100000)form.setFieldsValue({ allowed_beneficiary_types: ['bank_account'] });
                        }} prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />}/>)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item colon={false} label={renderUniqueCodeLabel()}>
                        {getFieldDecorator("unique_code", {
                            rules: validations.unique_code
                        })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderUniqueCodeExtra()} />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Expiry Date">
                        {getFieldDecorator("expiry_date", {
                            rules: validations.expiry_date
                        })(<DatePicker style={{ width: "100%" }} disabledDate={(date) => date.valueOf() <= moment().valueOf()} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Notify Payee">
                        {getFieldDecorator("notify_payee", {
                            valuePropName: "checked",
                            initialValue: false
                        })(<Switch checkedChildren="Yes" unCheckedChildren="No" />)}
                    </Form.Item>
                </div>
                {/* <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item colon={false} label={renderSkipAuthenticationLabel()}>
                        {getFieldDecorator("skip_authentication", {
                            rules: validations.skip_authentication,
                            valuePropName: "checked",
                            initialValue: false
                        })(<Switch checkedChildren="Yes" unCheckedChildren="No" />)}
                    </Form.Item>
                </div> */}
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Form.Item label="Allowed Beneficiary Types">
                        {getFieldDecorator("allowed_beneficiary_types", {
                            rules: validations.allowed_beneficiary_types,
                            initialValue: getBeneficiaryTypesInitialValue()
                        })(<Checkbox.Group options={props.form.getFieldValue("amount") <=100000 || props.form.getFieldValue("amount") == undefined ?getBeneficiaryTypes() : getBeneTypes()}/>)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Form.Item label="Description">
                        {getFieldDecorator("description", {
                            rules: validations.description
                        })(<TextArea ows={1} />)}
                    </Form.Item>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12" style={{fontSize: "12px"}}>
                    <b>Note: </b><br></br>
                    <i>Payout link will deactivate automatically after 3 failed attempts.*</i>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-2">
                <Button type="primary" htmlType="submit" loading={props.loading}>Create</Button>
            </div>
        </Form >
    )
};

PayoutLinkForm.defaultProps = {
    payout_link: {}
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

PayoutLinkForm = Form.create()(PayoutLinkForm);

export default connect(mapStateToProps)(PayoutLinkForm);